import { getField, updateField } from 'vuex-map-fields';

export default {
    namespaced: true,

    state: {
        Message: '',
    },

    getters: {
        getField,
    },

    actions: {
        submit({ state }, tenancyPK) {
            return axios.post(`/api/contacts/tenancies/${tenancyPK}/inventory-feedback`, state);
        },
    },

    mutations: {
        updateField,
    },
};
